import styled from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
import tokens from '../../../foundation/tokens/js/tokens';
// styled-components.
// -----------------------------------------------------------------------------
export const BaseTableLoadingRoot = styled.tr ``;
export const BaseTableLoadingTitle = styled.div `
  color: ${tokens.colors.midnight[500].value};
  text-transform: uppercase;
`;
export const BaseTableLoadingWrapper = styled.div `
  // Box.
  align-items: center;
  display: flex;
  flex-direction: column;

  // Spacing.
  gap: ${getSpace('xl')};
  margin: ${getSpace('5xl')};
`;
//# sourceMappingURL=BaseTableLoading.styled.js.map